import React, { useMemo } from "react";
import "./avatar.css";

const LettersAvatar = ({
  fontSize,
  height,
  width,
  roundedFull = false,
  user,
}) => {
  const firstName = user?.contactName?.first;
  const lastName = user?.contactName?.last;
  const imageSrc = user?.imageSrc !== "Null" ? user.imageSrc : null;
  const userFunction = user?.function;
  const companyName = user?.accountNo?.company || user?.accountNo?.companyInfo?.company;

  const firstNameInitial = firstName?.[0]?.toUpperCase() || "";
  const lastNameInitial = lastName?.[0]?.toUpperCase() || "";

  const getRandomColor = useMemo(() => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 15)];
    }
    return color !== "#000000" ? color : getRandomColor();
  }, []);

  const avatarStyle = {
    backgroundColor: getRandomColor,
    color: "#ffffff",
    fontSize: fontSize ?? "18px",
    height: height ?? 55,
    width: width ?? 55,
  };

  const borderRadiusClass = roundedFull ? "rounded-circle" : "rounded";

  return (
    <div className="d-flex flex-column align-items-center text-center">
      <div className={`bg-white p-1 ${borderRadiusClass}`}>
        {imageSrc ? (
          <img
            src={imageSrc}
            height={height ?? 55}
            width={width ?? 55}
            alt={`${firstName} ${lastName}`}
            className={`avatar-image object-fit-cover ${borderRadiusClass}`}
          />
        ) : (
          <div
            className={`d-flex align-items-center justify-content-center ${borderRadiusClass}`}
            style={avatarStyle}
          >
            <span>{firstNameInitial}</span>
            <span>{lastNameInitial}</span>
          </div>
        )}
      </div>

      {(userFunction || companyName) && (
        <div className="mt-1">
          {userFunction && (
            <div className="text-muted" style={{ fontSize: "0.65rem", lineHeight: "1" }}>
              {userFunction}
            </div>
          )}
          {companyName && (
            <div className="text-muted" style={{ fontSize: "0.6rem", lineHeight: "1" }}>
              {companyName}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LettersAvatar;
